import { ApprovalDeadline } from "../@types/ApprovalDeadline";
import { api } from "./api";

export const fetchDeadline = async (): Promise<ApprovalDeadline> => {
  const response = await api.get<ApprovalDeadline>(`/deadline/next`);
  return response.data;
};
